/* Silumen : flèches des carrousels de la fiche produit ([data-slm-carousel]) */
(function () {
  function init(root) {
    if (!root) return;
    if (root.getAttribute('data-slm-car')) { if (root._slmUpdate) root._slmUpdate(); return; }
    var track = root.querySelector('[data-slm-track]');
    if (!track) return;
    root.setAttribute('data-slm-car', '1');
    var prev = root.querySelector('[data-slm-prev]');
    var next = root.querySelector('[data-slm-next]');
    function step() {
      var c = track.firstElementChild;
      var gap = parseFloat(getComputedStyle(track).columnGap) || 14;
      var w = c ? c.getBoundingClientRect().width + gap : track.clientWidth * 0.8;
      return Math.max(1, Math.floor(track.clientWidth / w)) * w;
    }
    function update() {
      var over = track.scrollWidth > track.clientWidth + 2;
      if (prev) prev.hidden = !over || track.scrollLeft <= 2;
      if (next) next.hidden = !over || track.scrollLeft >= track.scrollWidth - track.clientWidth - 2;
    }
    if (prev) prev.addEventListener('click', function (e) { e.preventDefault(); track.scrollBy({ left: -step(), behavior: 'smooth' }); });
    if (next) next.addEventListener('click', function (e) { e.preventDefault(); track.scrollBy({ left: step(), behavior: 'smooth' }); });
    track.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    root._slmUpdate = update;
    update();
    setTimeout(update, 400);
  }
  window.slmCarousel = init;
  function all() { document.querySelectorAll('[data-slm-carousel]').forEach(init); }
  if (document.readyState !== 'loading') all(); else document.addEventListener('DOMContentLoaded', all);
  window.addEventListener('load', all);
})();